import { useImmer } from "use-immer";

import { formatLastUpdatedText } from "@intelligems/ig-utils/date-time";
import { useInterval } from "@intelligems/ig-utils/useInterval";

/** "just now" inside the first minute, then "2m ago", kept current. */
export const savedAgoLabel = (savedAtTs: number | null, now: number) =>
  formatLastUpdatedText(savedAtTs, {
    noPrefix: true,
    justNowThresholdMs: 60_000,
    fallback: "just now",
    now,
  });

export const useSavedAgo = (savedAtTs: number | null) => {
  const [now, setNow] = useImmer(Date.now());
  // Nothing saved yet reads "just now" whatever the time, so nothing ticks.
  useInterval(() => setNow(Date.now()), savedAtTs === null ? null : 30_000);
  return savedAgoLabel(savedAtTs, Math.max(now, savedAtTs ?? 0));
};
